import { ChatMessage, Tool, Conversation } from '../../../../@types/IA.type';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store'; 
import DeclarationReceiptTool from '../tools/DeclarationReceiptTool';
import GenerateComplementaryDeclarationTool from '../tools/GenerateComplementaryDeclarationTool';
import EscalationFormTool from '../tools/EscalationForm';

const ChatTools = ({
	message,
	conversation,
	tools,
	index,
}: {
	message: ChatMessage;
	conversation: Conversation;
	tools: Tool[];
	index: number;
}) => {
	const userProfile = useSelector((state: RootState) => state.profile.user);
 

 
	 
	const toolsDictionary: Record<
		string,
		(props: {
			tool: Tool;
			userProfile?: any;
			userIsPlatec?: boolean;
			message?: ChatMessage;
		}) => React.ReactNode
	> = {
		acuse_declaracion_presentada: (props) => (
			<DeclarationReceiptTool
				tool={props.tool}
				userIsPlatec={true}
				userProfile={userProfile}
			/>
		),
		crear_declaracion_complementaria: (props) => (
			<GenerateComplementaryDeclarationTool
				tool={props.tool}
				userIsPlatec={true}
				userProfile={userProfile}
			/>
		),
		form_hablar_con_agente_soporte: (props) => (
			<EscalationFormTool
				tool={props.tool}
				userProfile={userProfile}
				message={message}
				conversation={conversation}
			/>
		),
	};
 
	return (
		<div
			className='flex flex-col gap-2'
			style={{
				animation: 'fadeInScale 0.3s ease forwards',
				animationDelay: `${index * 50}ms`,
				opacity: 0,
			}}
		>
			{tools?.map((tool) => {
				const ToolComponent = toolsDictionary[tool.name];
				return ToolComponent ? (
					<div key={tool.name}>{ToolComponent({ tool })}</div>
				) : null;
			})}
		</div>
	);
};

export default ChatTools;
